import React from "react";
import { ActionHandlerFunction } from "@preveil-api";
import { DriveUIActionTypes } from "src/common";
import { ToolbarWrapper } from "src/components";

type AllProps = {
  is_loading: boolean;
  total: number;
  handleAction: ActionHandlerFunction;
};

function ToolbarComponent(props: AllProps) {
  const { is_loading, handleAction, total } = props;
  const count_label = total === 1 ? `${total} Invitation` : total > 1 ? `${total} Invitations` : "";

  return (
    <ToolbarWrapper
      paginationInfo={<span className="pagination_info">{count_label}</span>}
      refreshAction={() => handleAction({ actionType: DriveUIActionTypes.Refresh })}
      refreshTooltipContent="Refresh Invitations"
      isLoading={is_loading}
    />
  );
}

export default React.memo(ToolbarComponent);
